export default {

    arrowDownSvg: function() {

        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n" +
                                               "        <defs>\n" +
                                               " <clipPath id=\"clip-Arrow_Down_Red\">\n" +
                                              "                <rect width=\"24\" height=\"24\"/>\n" +
                                            "  </clipPath>\n" +
                                            "        </defs>\n" +
                                             " <g id=\"ArrowDown_Red\" clip-path=\"url(#clip-ArrowDown_Red)\">\n" +
                                               " <g id=\"Group_38\" data-name=\"Group 38\">
                                                "  <path id=\"Path_33\" data-name=\"Path 33\" d=\"M0,24H24V0H0Z\" fill=\"#a43a45\" opacity=\"0\"/>\n" +
                                                 " <path id=\"Path_34\" class="svg-primary-color" data-name=\"Path 34\" d=\"M7.41,8,12,12.58,16.59,8,18,9.41l-6,6-6-6Z\" transform=\"translate(0 0.59)\" '/>\n" +
                                                "</g>\n" +
                                              "</g>\n" +
                                            "</svg>`;
    }
};



// WEBPACK FOOTER //
// ./src/common/plugins/svg/ArrowDownPlugin.js